import { InvoiceLineModel } from "./invoiceline.model";
import { QRCodeModel } from "../../qr/qrcode.model";
import { ContactActivitiesModel } from "../../contact/contact/contactActivities.model";

export class ExpenseFormModel {
  uid: string;
  invoiceLines: Array<InvoiceLineModel>;
  published: boolean;
  contabilized: boolean;
  activityUid: string;
  activityName: string;

  issuerName: string;
  issuerVatNumber: string;
  issuerAddress: string;
  issuerLocation: string;
  issuerPostalCode: string;
  issuerState: string;
  issuerCountry: string;

  receiverName: string;
  receiverVatNumber: string;
  receiverAddress: string;
  receiverLocation: string;
  receiverPostalCode: string;
  receiverState: string;
  receiverCountry: string;

  receiverUid: string;
  preInvoiceNumber: string;
  invoiceNumber: string;
  invoiceRelease: Date;
  invoiceExpiration: Date;
  received: Date;
  sendedMail: Date;
  paided: Date;
  returned: Date;
  recurrentNumber: string;
  recurrentFrequency: string;
  recurrentStart: Date;
  isNative: boolean;
  isReceptor: boolean;
  base: number;
  total: number;
  totalPaided: number;
  pending: number;
  typePay: string;
  typePayBankAccount: string;
  expenseAccount: string;
  entranceAccount: string;
  rectifying: boolean;
  comments: string;
  qrcode: QRCodeModel;
  qrstring: string;
  publish: boolean;
  isDigital: boolean;
  isSelected: boolean;
  fiscalYear: number;

  image: boolean;
  pdf: boolean;
  fileUid: string;

  isIncomplete: boolean;
  incompleteMessage: string;

  contactActivities: Array<ContactActivitiesModel>;

  accounted: string;

  exportedToExcel: boolean;

  efectivoId: string;
  partnersId: number;
  polizaCreditoId: string;

  comment: string;

  attachmentApprovalFile: boolean;
  isValidHashInvoiceApproval: boolean;

  projectUid?: string;
  expenseProjectTypeUid?: string;

  constructor() { }

}
